import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.5146 8.45447C13.6146 8.45447 14.5146 7.55447 14.5146 6.45447C14.5146 5.35447 13.6146 4.45447 12.5146 4.45447C11.4146 4.45447 10.5146 5.35447 10.5146 6.45447C10.5146 7.55447 11.4146 8.45447 12.5146 8.45447ZM12.5146 10.4545C11.4146 10.4545 10.5146 11.3545 10.5146 12.4545C10.5146 13.5545 11.4146 14.4545 12.5146 14.4545C13.6146 14.4545 14.5146 13.5545 14.5146 12.4545C14.5146 11.3545 13.6146 10.4545 12.5146 10.4545ZM12.5146 16.4545C11.4146 16.4545 10.5146 17.3545 10.5146 18.4545C10.5146 19.5545 11.4146 20.4545 12.5146 20.4545C13.6146 20.4545 14.5146 19.5545 14.5146 18.4545C14.5146 17.3545 13.6146 16.4545 12.5146 16.4545Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }